import { longTailKeywordProductsPageSize } from '@/modules/config/catalogue'
import { filterByType } from '@/modules/api/helpers'
import Product from '@/modules/api/product'

const productApi = new Product()

const state = {
  longTailKeyword: null,
  relatedKeywords: [],
  products: [],
  variants: [],
  reviews: []
}

const getters = {
  featuredVariantForLTKWProduct: (state) => (product) => {
    return state.variants.find(v => v.id === product.relationships['featured-variant'].data.id)
  },

  featuredReviewForLTKWProduct: (state) => (product) => {
    return state.reviews.find(r => r.id === product.relationships['featured-review'].data.id)
  }
}

const mutations = {
  setLongTailKeyword (state, object) {
    state.longTailKeyword = object
  },

  setRelatedKeywords (state, array) {
    state.relatedKeywords = array
  },

  setLongTailKeywordProducts (state, array) {
    state.products = array
  },

  setLongTailKeywordVariants (state, array) {
    state.variants = array
  },

  setLongTailKeywordReviews (state, array) {
    state.reviews = array
  }
}

const actions = {
  async fetchLongTailKeyword ({ commit }, keywordSlug) {
    const { data, included } = await productApi.fetchLongTailKeyword(keywordSlug)
    commit('setLongTailKeyword', data)
    if (included) {
      commit('setRelatedKeywords', filterByType(included, 'long-tail-keywords'))
    }
  },

  async fetchLongTailKeywordProducts ({ commit }, { keyword, categoryId = null }) {
    const { data, included } = await productApi.fetchLongTailKeywordProducts(keyword, longTailKeywordProductsPageSize, categoryId)
    commit('setLongTailKeywordProducts', data)
    commit('setLongTailKeywordVariants', filterByType(included, 'variants'))
    commit('setLongTailKeywordReviews', filterByType(included, 'reviews'))
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
